import React from 'react';
// Leaves only — never the `./shell` barrel. This file is reached from PersonDrawer (which
// AdminShell mounts), so a barrel import here would close the cycle that leaves every
// token undefined at module-evaluation time.
import { InitialsBox, relTime } from './shell/ui';

/** Shared row shape for the activity log: AUDIT LOG, the USERS record's sub-tab, the STAFF person feed. */
export function activityColumns({ withWho = true, withSection = true, onToggle, open }) {
  return [
    withWho && { key: 'who', label: 'WHO', fr: 0.6, render: (r) => <InitialsBox initials={r.actorInitials} name={r.actorName} /> },
    { key: 'summary', label: 'WHAT', fr: 2.6, render: (r) => <span className={`normal-case ${r.severity === 'critical' ? 'font-bold' : ''}`}>{r.summary}</span> },
    withSection && { key: 'section', label: 'SECTION', fr: 1, render: (r) => r.section || '—' },
    { key: 'target', label: 'RECORD', fr: 1.2, render: (r) => r.targetLabel || r.targetId || '—' },
    { key: 'createdAt', label: 'WHEN', fr: 0.9, render: (r) => relTime(r.createdAt) },
    { key: 'kind', label: 'KIND', fr: 0.8, render: (r) => (r.kind === 'write' && onToggle ? <button type="button" onClick={(e) => { e.stopPropagation(); onToggle(r.id); }} className="uppercase">WRITE {open?.has(r.id) ? '▴' : '▾'}</button> : r.kind.toUpperCase()) },
  ].filter(Boolean);
}
